import axios, { AxiosPromise } from 'axios';
import {
  IGetOrderInfo,
  IGetPaymentOverallSales,
  IGetPaymentRecords,
  IGetPosResultInfo,
  IGetSalesStats,
  IPaymentOverallSalesParams,
  IPaymentRecordParams,
  IPaymentStatusResponse,
  IPostStudentPaymentTodo,
  ISalesStatsPeriodParams,
  IUpdatePaymentLastBody,
} from '../models/nicePayments.model';
import QueryString from 'qs';
import { handleEmptyString } from '../lib/util';
import { IResponse } from '../models/common.api.model';

const posUri = '/service/nice-pos-payments';
const vanUri = '/service/nice-van-payments';
const mgmtUri = '/mgmt/nice-payments';

export const createNicePaymentTodo = (
  body: any,
): AxiosPromise => {
  return axios.put(`${posUri}/tran-order-todo`, body);
};

export const postNicePaymentLog = (
  body: any,
): AxiosPromise<IGetOrderInfo> => {
  return axios.post(`${posUri}/log`, body);
};

export const updatePaymentTodo = (
  body: IUpdatePaymentLastBody,
): AxiosPromise<IGetOrderInfo> => {
  return axios.post(`${posUri}/order-id`, body);
};

export const adminPaymentTodo = (
  body: IUpdatePaymentLastBody,
): AxiosPromise<IGetOrderInfo> => {
  return axios.post(`${posUri}/admin-order-todo`, body);
};

export const cancelPaymentTodo = (
  paymentRecordCode: number,
): AxiosPromise<IGetOrderInfo> => {
  return axios.post(`${posUri}/cancel/${paymentRecordCode}`);
};

export const replaceNicePaymentTodo = (
  orgPaymentRecordCode: number,
  newPaymentRecordCode: number,
  body: any,
): AxiosPromise => {
  return axios.put(
    `${posUri}/temp-change/${orgPaymentRecordCode}/${newPaymentRecordCode}/todo`,
    body,
  );
};

export const replaceNiceVanPaymentTodo = (
  orgPaymentRecordCode: number,
  newPaymentRecordCode: number,
): AxiosPromise => {
  return axios.put(
    `${vanUri}/temp-change/${orgPaymentRecordCode}/${newPaymentRecordCode}/todo`,
  );
};

export const createTempNicePaymentTodo = (
  memberCode: string,
  paymentRecordCode: number,
  data: { installment: number },
): AxiosPromise<IPostStudentPaymentTodo> => {
  return axios.post(
    `${posUri}/temp-list/${memberCode}/${paymentRecordCode}/todo`,
    data,
  );
};

export const getPosResultInfo = (
  paymentRecordCode: number,
): AxiosPromise<IGetPosResultInfo> => {
  return axios.get(
    `${posUri}/pos-result/${paymentRecordCode}`,
  );
};

export const getFilterData = (
  paymentRecordCode: number,
): AxiosPromise<IResponse<string>> => {
  return axios.get(
    `${posUri}/filter-data/${paymentRecordCode}`,
  );
};

export const getPaymentRecords = (
  params: IPaymentRecordParams,
): AxiosPromise<IGetPaymentRecords> => {
  const qsParams = QueryString.stringify(handleEmptyString(params));
  return axios.get(`${mgmtUri}/pay-list?${qsParams}`);
};

export const getPaymentOverallSales = (
  params?: IPaymentOverallSalesParams,
): AxiosPromise<IGetPaymentOverallSales> =>
  axios.get(`${mgmtUri}/overall-sales`, { params });

export const getSalesPeriodStats = (
  params: ISalesStatsPeriodParams,
): AxiosPromise<IGetSalesStats> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${mgmtUri}/sales?${qsParams}`);
};

export const getPaymentStatus = (
  paymentNo: number,
): AxiosPromise<IResponse<IPaymentStatusResponse>> => {
  return axios.get(`${posUri}/status/${paymentNo}`);
};

export const updatePaymentStatus = (
  paymentNo: number,
  status: string,
  statusDesc?: string,
): AxiosPromise<IResponse<any>> => {
  return axios.put(`${posUri}/status/${paymentNo}`, null, {
    params: { status, statusDesc }
  });
};